import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Instagram, Facebook, Youtube } from "lucide-react";
import { useSettings } from "../../lib/settings";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer data-testid="site-footer" className="border-t border-[hsl(var(--line))] bg-[hsl(var(--sand))]">
      <div className="container-x py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="display text-3xl text-[hsl(var(--ink))]">{settings.church_name}</div>
            <p className="mt-5 text-sm text-[hsl(var(--ink-muted))] max-w-md leading-relaxed">
              {settings.footer_blurb}
            </p>
            <div className="mt-8 flex items-center gap-5 text-[hsl(var(--ink-muted))]">
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="hover:text-[hsl(var(--terracotta))] transition-colors"><Instagram size={18} /></a>
              )}
              {settings.facebook_url && (
                <a href={settings.facebook_url} target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="hover:text-[hsl(var(--terracotta))] transition-colors"><Facebook size={18} /></a>
              )}
              {settings.youtube_url && (
                <a href={settings.youtube_url} target="_blank" rel="noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="hover:text-[hsl(var(--terracotta))] transition-colors"><Youtube size={18} /></a>
              )}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/sermons" className="under-line">Sermons</Link></li>
              <li><Link to="/prayer" className="under-line">Prayer Wall</Link></li>
              <li><Link to="/give" className="under-line">Give</Link></li>
              <li><Link to="/events" className="under-line">Events</Link></li>
              <li><Link to="/about" className="under-line">About & Pastors</Link></li>
              <li><Link to="/visit" className="under-line">Plan a visit</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow mb-5">Visit</div>
            <ul className="space-y-3 text-sm text-[hsl(var(--ink-muted))]">
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0" /> {settings.address_line1}{settings.address_line2 && <>, {settings.address_line2}</>}</li>
              {settings.email && <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 shrink-0" /> {settings.email}</li>}
              {settings.phone && <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 shrink-0" /> {settings.phone}</li>}
            </ul>
            <div className="mt-6 text-sm">
              <div className="text-[hsl(var(--ink))]">Sundays</div>
              <div className="text-[hsl(var(--ink-muted))]">{settings.sunday_service_1} · {settings.sunday_service_2}</div>
            </div>
          </div>
        </div>

        <div className="mt-16 rule pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[hsl(var(--ink-muted))]">
          <div>© {new Date().getFullYear()} {settings.church_name}. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" data-testid="footer-admin-link" className="under-line">Staff Sign-in</Link>
            <span>·</span>
            <span>Made with care</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
